<template>
    <button :class="{blue: color === 'blue',fullWidth:fullWidth}" @click="$emit('click')" :type="type"><slot></slot></button>
</template>

<script>
    export default {
        props:{
            type:{
                type:String,
                default:'button'
            },
            color:{
                type:String
            },
            fullWidth:{
                type:Boolean,
                default:false
            }

        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/variables.scss';
    button{
        border-radius:5px;
        padding:10px 20px;
        line-height: 1.5;
        cursor: pointer;

        
    }

    .fullWidth{
        flex-grow: 1;
    }
    
    .blue{
        outline: none;
        background-color: #FFD100;
        color:black
    ;
        border-radius: 45px;
        background-position: center;
        width: 140px;
        margin-left:auto;
        transition: all 0.8s;
         &:hover{
            transition: all 0.4s;
            background: #D6AF00;
        }
        &:active{
              background-color:  #D6AF00 ;
              background-size: 100%;
              transition: all 0s;
        }
    }
</style>